import React, { Component } from "react";
import { NavLink, Link } from "react-router-dom";
import isEmpty from "lodash.isempty";
import map from "lodash.map";
import orderBy from "lodash.orderby";
import moment from "moment";
import Truncate from "react-truncate";
import { RouteUrls } from "../../../configs/routeUrls";
import {
  BudgetStatus,
  ProjectStatus,
  ExpendActionType,
} from "../../../utils/enums";
import { dayFormat } from "../../../utils/date";
import { replaceEndOfLine } from "../../../utils/text-extensions";

export class BudgetListItem extends Component {
  constructor(props) {
    super(props);

    this.toggleOpen = (e) => {
      e.preventDefault();
      e.stopPropagation();
      if (this.props.opened) {
        this.props.onSetExpandStateItem(ExpendActionType.remove, this.props.id);
      } else {
        this.props.onSetExpandStateItem(ExpendActionType.add, this.props.id);
      }
    };

    this.replaceEndOfLine = replaceEndOfLine.bind(this);
  }

  canVote = (budget, isAuth) => {
    if (!budget) {
      return;
    }
    const { loggedOfficeId, officeId } = this.props;

    const isCanVote =
      budget.consultationForms && budget.consultationForms.length > 0
        ? budget.consultationForms.some(
            (item) =>
              !item.voted &&
              !item.outOfRangeVoteDates &&
              (!item.outOfRangeDistricts || item.availableVoteNotLogged)
          )
        : false;
    const isVoted =
      budget.consultationForms && budget.consultationForms.length > 0
        ? budget.consultationForms.every((item) => item.voted)
        : false;
    const isUserLegalAge = budget.onlyForLegalAge
      ? budget.isLegalAgeUser
      : true;
    return budget.merge({
      isVoted: isVoted,
      isCanVote:
        isCanVote &&
        (loggedOfficeId === officeId || budget.availableVoteNotLogged) &&
        budget.status === ProjectStatus.Active &&
        !budget.votedForAllForms &&
        (isAuth || budget.availableVoteNotLogged) &&
        (isUserLegalAge || budget.availableVoteNotLogged),
    });
  };

  render() {
    const {
      id,
      title,
      statusName,
      officeId,
      loggedOfficeId,
      officeName,
      description,
      budgetYearValue,
      budgetYearId,
      status,
      isAuth,
      votes,
      isOnlyOneOffice,
      opened,
    } = this.props;

    return (
      <div className="consultations__item">
        <div className={`consultations__header`} onClick={this.toggleOpen}>
          <div className="consultations__title">{title}</div>
          <div className="consultations__icons">
            <Link
              to={RouteUrls.Budget.pages.prerequisiteFunc(budgetYearValue)}
              title="Do pobrania"
            >
              <i className="link link__icon link__icon-biggest link__icon-left link--primary-dark fas fa-download" />
            </Link>
            <Link
              to={RouteUrls.Budget.pages.scheduleFunc(budgetYearValue)}
              title="Harmonogram"
            >
              <i className="link link__icon link__icon-biggest link__icon-left link--primary-dark fas fa-calendar-alt" />
            </Link>
            <Link
              to={RouteUrls.Budget.pages.helpFunc(budgetYearValue)}
              title="Pomoc"
            >
              <i
                className={`link link__icon link__icon-biggest ${
                  !opened ? "link__icon-left" : ""
                } link--primary-dark fas fa-question-circle`}
              />
            </Link>
            <div
              className="consultations__switch consultations__switch--primary-dark"
              onClick={this.toggleOpen}
            >
              {opened ? "Zwiń" : "Rozwiń"}
              {
                <i
                  className={`consultations__icon fas fa-angle-${
                    opened ? "up" : "down"
                  }`}
                />
              }
            </div>
          </div>
        </div>
        {opened && (
          <div className="consultations__body">
            <div className="consultations__projects consultations__projects--space-between">
              <Link
                className="consultations__projects-link consultations__projects-link--primary-dark"
                to={RouteUrls.Budget.projectTasks.listForYear(budgetYearId)}
                title={`Lista projektów w roku ${budgetYearValue}`}
              >
                Pokaż wszystkie projekty w roku
              </Link>
              <Link
                className="consultations__projects-link consultations__projects-link--primary-dark"
                to={RouteUrls.Budget.projectTasks.acceptedListForYear(
                  budgetYearId
                )}
                title={`Lista zaakceptowanych projektów`}
              >
                Lista zaakceptowanych projektów
              </Link>
            </div>
            {!isEmpty(votes) &&
              map(orderBy(votes, ["dateTo"]), (vote, voteIndex) => {
                let newBudgetVote = this.canVote(vote, isAuth);
                const dateTimeNow = moment();
                const dateToMoment = moment(newBudgetVote.dateTo);
                const dateFromMoment = moment(newBudgetVote.dateFrom);
                let countOfDistricts = vote.consultationForms
                  ? vote.consultationForms.length
                  : 0;
                let countOfProjects = vote.consultationForms.reduce(
                  (totalProjects, currConsultationForm) =>
                    totalProjects +
                    currConsultationForm.categories.reduce(
                      (prevCategory, currCategory) =>
                        prevCategory + currCategory.questions.length,
                      0
                    ),
                  0
                );

                const substringDescription = newBudgetVote.description
                  ? newBudgetVote.description.substring(0, 270)
                  : "";
                return (
                  <div key={`vote-${voteIndex}`} className="consultation-item">
                    <div className="consultation-item__header">
                      {newBudgetVote.title}
                    </div>
                    <div className="consultation-item__body">
                      <div className="consultation-item__desc margin-right-20">
                        <div className="consultation-description__text">
                          <Truncate
                            lines={5}
                            ellipsis={
                              <span>
                                ...
                                <NavLink
                                  to={`${RouteUrls.Budget.vote.previewFunc(
                                    this.props.budgetYearValue,
                                    newBudgetVote.id
                                  )}`}
                                  className="link"
                                  title="Szczegóły projektu"
                                >
                                  &nbsp;więcej
                                </NavLink>
                              </span>
                            }
                          >
                            <div
                              style={{ display: "inline" }}
                              dangerouslySetInnerHTML={{
                                __html: `${this.replaceEndOfLine(
                                  substringDescription
                                )}`,
                              }}
                            />
                          </Truncate>
                        </div>
                      </div>
                      <div className="consultation-item__infos">
                        <div className="consultation-item__info">
                          <div className="consultation-item__info-label">
                            Głosowanie od:{" "}
                          </div>
                          <div className="consultation-item__info-value">
                            {`${dayFormat(newBudgetVote.dateFrom)}`}
                          </div>
                          <div className="consultation-item__info-label">
                            {" "}
                            do:{" "}
                          </div>
                          <div className="consultation-item__info-value">
                            {`${dayFormat(newBudgetVote.dateTo)}`}
                          </div>
                        </div>
                        {!isOnlyOneOffice && (
                          <div className="consultation-item__info">
                            <div className="consultation-item__info-label">
                              Jednostka:{" "}
                            </div>
                            <div className="consultation-item__info-value">
                              {officeName}
                            </div>
                          </div>
                        )}
                        {isAuth && (
                          <div className="consultation-item__info">
                            <div className="consultation-item__info-label">
                              Oddany głos:
                            </div>
                            <div className="consultation-item__info-value">
                              {newBudgetVote.isVoted ? "Tak" : "Nie"}
                            </div>
                          </div>
                        )}
                        <div className="consultation-item__info">
                          <div className="consultation-item__info-label">
                            Liczba obszarów:
                          </div>
                          <div className="consultation-item__info-value">
                            {countOfDistricts}
                          </div>
                        </div>
                        <div className="consultation-item__info">
                          <div className="consultation-item__info-label">
                            Liczba projektów:
                          </div>
                          <div className="consultation-item__info-value">
                            {countOfProjects}
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="consultation-item__footer">
                      {status !== BudgetStatus.Finished &&
                        newBudgetVote.status < ProjectStatus.Close &&
                        !newBudgetVote.isCanVote &&
                        dateFromMoment.isSameOrBefore(dateTimeNow) &&
                        dateToMoment.isSameOrAfter(dateTimeNow) && (
                          <div className="consultations__projects">
                            <a
                              disabled={this.props.id === 0}
                              className="button button--primary-dark button--width-auto"
                              title="Przejdź do szczegółów"
                              onClick={() =>
                                this.props.onProjectPreview(
                                  this.props.budgetYearValue,
                                  newBudgetVote.id
                                )
                              }
                            >
                              Przejdź do szczegółów
                            </a>
                          </div>
                        )}
                      {status !== BudgetStatus.Finished &&
                        newBudgetVote.status < ProjectStatus.Close &&
                        newBudgetVote.isCanVote &&
                        dateFromMoment.isSameOrBefore(dateTimeNow) &&
                        dateToMoment.isSameOrAfter(dateTimeNow) && (
                          <div className="consultations__projects">
                            <a
                              disabled={this.props.id === 0}
                              className="button button--primary-dark button--width-auto"
                              title="Przejdź do głosowania"
                              onClick={() =>
                                this.props.onProjectVote(
                                  this.props.budgetYearValue,
                                  newBudgetVote.id
                                )
                              }
                            >
                              Przejdź do głosowania
                            </a>
                          </div>
                        )}
                      {(status === BudgetStatus.Finished ||
                        newBudgetVote.status >= ProjectStatus.Close ||
                        dateFromMoment.isAfter(dateTimeNow) ||
                        dateToMoment.isBefore(dateTimeNow)) &&
                        newBudgetVote.showResults && (
                          <div className="consultations__projects">
                            <Link
                              disabled={this.props.id === 0}
                              className="button button--primary-dark button--width-auto"
                              title="Przejdź do wyników"
                              to={RouteUrls.Budget.vote.resultFunc(
                                budgetYearValue,
                                newBudgetVote.id
                              )}
                            >
                              Przejdź do wyników
                            </Link>
                          </div>
                        )}
                    </div>
                  </div>
                );
              })}
            {isEmpty(votes) && (
              <div className="consultation-item">
                <div className="consultation-item__body">
                  <div className="consultation-item__desc">
                    <div className="consultation-description__text">
                      {
                        // <Truncate lines={5} ellipsis={<span>...</span>}>
                      }
                      <div
                        style={{ display: "inline" }}
                        dangerouslySetInnerHTML={{
                          __html: `${this.replaceEndOfLine(description)}`,
                        }}
                      />
                      {
                        // </Truncate>
                      }
                    </div>
                  </div>
                </div>
              </div>
            )}
          </div>
        )}
      </div>
    );
  }
}
